import { omitBy } from 'lodash';
import request from '../../../request/request';

const getPolicies = ({ page, size, keyword }) => {
  return request({
    url: `/webapi/policies`,
    params: omitBy(
      {
        page: page - 1,
        size,
        keyword
      },
      value => value === undefined || value.toString().trim() === ''
    )
  });
};

const createPolicy = ({ name, description, code }) => {
  return request({
    url: '/webapi/policies',
    method: 'POST',
    data: { name, description, ...code }
  });
};

export { getPolicies, createPolicy };
